export const ADMIN_LISTS = ["companies", "clients"] as const;
export type AdminList = (typeof ADMIN_LISTS)[number];

export const DEFAULT_ADMIN_LIST: AdminList = "companies";

export function isAdminList(value: unknown): value is AdminList {
    return ADMIN_LISTS.includes(value as AdminList);
}

/**
 * Path the admin should be redirected to, or null when the current route is already canonical.
 * Handles the root path, unknown lists, and the legacy `?company=<id>` deep links.
 */
export function adminRedirect(path: string, params: { [param: string]: string }, list: unknown): string | null {
    if (params.company) {
        return `companies/${params.company}`;
    }
    if (!path || !isAdminList(list)) {
        return DEFAULT_ADMIN_LIST;
    }
    return null;
}
